import { comics } from '@/mocks/comics';
import { CATEGORIES } from '@/mocks/comics';

interface Props {
  category: string;
  setCategory: (v: string) => void;
  status: string;
  setStatus: (v: string) => void;
  keyword: string;
  setKeyword: (v: string) => void;
}

const statuses = ['全部', '连载中', '已完结'];

export default function ComicFilters({ category, setCategory, status, setStatus, keyword, setKeyword }: Props) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex flex-wrap items-center gap-2" role="tablist" aria-label="漫画分类">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              type="button"
              role="tab"
              aria-selected={category === c}
              onClick={() => setCategory(c)}
              className={`rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                category === c
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <div className="flex rounded-full bg-background-100 p-1">
            {statuses.map((s) => (
              <button
                key={s}
                type="button"
                onClick={() => setStatus(s)}
                className={`rounded-full px-4 py-1.5 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  status === s ? 'bg-accent-500 text-foreground-950' : 'text-foreground-600 hover:text-foreground-950'
                }`}
              >
                {s}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="relative max-w-md">
        <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-lg text-foreground-400"></i>
        <input
          type="search"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          placeholder="搜索漫画名称或作者…"
          aria-label="搜索漫画"
          className="w-full rounded-full border border-background-200 bg-background-50 py-2.5 pl-11 pr-4 text-sm text-foreground-950 outline-none placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
        />
      </div>
      <p className="text-xs text-foreground-500">
        共 {comics.length} 部漫画收录于本站追更库
      </p>
    </div>
  );
}